import { useTheme } from "@mui/material";
import { AccessibilityButtonStyle, LucidIconStyle } from "./LucidIcon.style";

type IProps = {
  id:string;
  disable?: boolean;
  icon:JSX.Element;
  onClick?:()=>void;
  size?: string;
  ariaLabel?:string;
  tabIndex?:number
}

export const LucidIcon = ({ id, disable, icon, size, ariaLabel, onClick, tabIndex }: IProps) => { 
  const theme = useTheme();
  return ( 
    <AccessibilityButtonStyle id={ id } aria-label={ ariaLabel } tabIndex={ tabIndex } onClick={ onClick }>
      <LucidIconStyle  disable={ disable } size={ size } theme={ theme } >
        { icon }
      </LucidIconStyle>
    </AccessibilityButtonStyle>
  );
};
